import { useEffect, useState } from "react";
import { Link, useLocation } from "wouter";
import { useAuth } from "@/hooks/use-auth";
import { loadPendingGeneration } from "@/lib/quote-generation-session";

export function PendingQuoteNotice() {
  const { user } = useAuth();
  const [path] = useLocation();
  const [pending, setPending] = useState(false);
  useEffect(() => {
    const check = () => {
      try { setPending(!!user?.id && !!loadPendingGeneration(user.id)); }
      catch { setPending(true); } // Never silently lose a malformed recovery reference.
    };
    check();
    window.addEventListener("storage", check);
    window.addEventListener("pageshow", check);
    document.addEventListener("visibilitychange", check);
    return () => {
      window.removeEventListener("storage", check);
      window.removeEventListener("pageshow", check);
      document.removeEventListener("visibilitychange", check);
    };
  }, [user?.id, path]);
  if (!pending || path === "/quotes/new") return null;
  return <div role="status" className="flex flex-wrap items-center justify-between gap-2 border-b bg-primary/5 px-4 py-2 text-xs">
    <span>You have a quotation to check or recover.</span>
    <Link href="/quotes/new?resume=1" className="font-medium text-primary underline underline-offset-2">Check quotation</Link>
  </div>;
}
